module.exports = __webpack_public_path__ + "img/SL7_4732-Bearbeitet.ab71f1d8.jpg";